var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.org.parent_organizations),function(parents,psidx){return _c('div',{key:`p-${psidx}`},_vm._l((parents),function(parent,pidx){return _c('span',{key:`p-${psidx}-${pidx}`},[_c('organization-link',{attrs:{"org":parent}}),_vm._v(" / ")],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }